<template>
    <div>
    	<div>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.maintain')}}: </span>
                    <span class="expand-value">{{ row.inMaintenance }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.recentEventsAmount')}}: </span>
                    <span class="expand-value">{{ row.recentEvents }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.nodeType')}}: </span>
                    <span class="expand-value">{{ row.nodeType }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.nodesAmount')}}: </span>
                    <span class="expand-value">{{ row.nodes }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.region')}}: </span>
                    <span class="expand-value">{{ row.zone }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.clusterParametersGroup')}}: </span>
                    <span class="expand-value">{{ row.clusterParameterGroup }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.clusterSubnetGroup')}}: </span>
                    <span class="expand-value">{{ row.clusterSubnetGroup }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.Redshift.subnet')}}: </span>
                    <span class="expand-value">{{ row.subnet }}</span>
                </Col>
            </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	display: block;
    	float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/redshift/TableExpand.vue